import React from "react"

const towndata = [
    {
        "id": "Abington",
        "totalpositivetests": 205,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 1153,
        "percentpositivity": "9.46%",
        "totalcumtests": 19060,
        "casecount": 190,
        "datepublished": "01/21/2021",
        "adir": 74.5,
        "total2weektests": 2167
    },
    {
        "id": "Acton",
        "datepublished": "01/21/2021",
        "casecount": 90,
        "adir": 27.1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 638,
        "percentpositivity": "3.46%",
        "total2weektests": 2864,
        "totalpositivetests": 99,
        "totalcumtests": 27351
    },
    {
        "id": "Acushnet",
        "casecount": 245,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 913,
        "totalpositivetests": 273,
        "datepublished": "01/21/2021",
        "adir": 167.5,
        "total2weektests": 2049,
        "totalcumtests": 14114,
        "percentpositivity": "13.32%"
    },
    {
        "id": "Adams",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 183,
        "totalpositivetests": 46,
        "datepublished": "01/21/2021",
        "totalcumtests": 8473,
        "total2weektests": 1023,
        "casecount": 44,
        "percentpositivity": "4.50%",
        "adir": 38.2
    },
    {
        "id": "Agawam",
        "totalcasecount": 1820,
        "totalcumtests": 40643,
        "adir": 83.2,
        "totalpositivetests": 372,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.31%",
        "total2weektests": 4474,
        "casecount": 332,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Alford",
        "totalcasecount": 5,
        "totalpositivetests": 0,
        "percentpositivity": "0%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 0,
        "total2weektests": 9,
        "datepublished": "01/21/2021",
        "totalcumtests": 165,
        "casecount": 0
    },
    {
        "id": "Amesbury",
        "totalcasecount": 814,
        "adir": 45.6,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 20125,
        "totalpositivetests": 128,
        "datepublished": "01/21/2021",
        "total2weektests": 2312,
        "percentpositivity": "5.54%",
        "casecount": 106
    },
    {
        "id": "Amherst",
        "percentpositivity": "2.90%",
        "casecount": 150,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 170,
        "totalcumtests": 188301,
        "adir": 26.6,
        "datepublished": "01/21/2021",
        "totalcasecount": 1037,
        "total2weektests": 5864
    },
    {
        "id": "Andover",
        "percentpositivity": "5.32%",
        "casecount": 284,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 1852,
        "adir": 56.2,
        "totalcumtests": 61765,
        "total2weektests": 6088,
        "totalpositivetests": 324
    },
    {
        "id": "Aquinnah",
        "adir": 27.4,
        "totalcumtests": 446,
        "casecount": 5,
        "datepublished": "01/21/2021",
        "total2weektests": 29,
        "percentpositivity": "3.45%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 5,
        "totalpositivetests": 1
    },
    {
        "id": "Arlington",
        "adir": 31.5,
        "totalcumtests": 71606,
        "total2weektests": 7941,
        "totalpositivetests": 228,
        "percentpositivity": "2.87%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 1274,
        "casecount": 202,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Ashburnham",
        "totalcumtests": 7335,
        "total2weektests": 837,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "10.39%",
        "totalcasecount": 268,
        "totalpositivetests": 87,
        "adir": 89.8,
        "casecount": 79
    },
    {
        "id": "Ashby",
        "casecount": 30,
        "percentpositivity": "10.49%",
        "totalpositivetests": 30,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 119,
        "totalcumtests": 2710,
        "adir": 61.4,
        "datepublished": "01/21/2021",
        "total2weektests": 286
    },
    {
        "id": "Ashfield",
        "datepublished": "01/21/2021",
        "percentpositivity": "2.42%",
        "casecount": 5,
        "totalcasecount": 24,
        "total2weektests": 124,
        "totalpositivetests": 3,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 1514,
        "adir": 12.6
    },
    {
        "id": "Ashland",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 232,
        "totalcasecount": 1097,
        "adir": 73.2,
        "casecount": 202,
        "percentpositivity": "6.76%",
        "totalcumtests": 26580,
        "total2weektests": 3432
    },
    {
        "id": "Athol",
        "total2weektests": 1424,
        "casecount": 88,
        "totalcasecount": 474,
        "adir": 52.5,
        "totalcumtests": 14847,
        "totalpositivetests": 94,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "6.60%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Attleboro",
        "total2weektests": 5144,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.47%",
        "casecount": 342,
        "totalcumtests": 49924,
        "totalcasecount": 2906,
        "adir": 52.5,
        "totalpositivetests": 384
    },
    {
        "id": "Auburn",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 183,
        "totalpositivetests": 198,
        "adir": 79.3,
        "totalcasecount": 1141,
        "percentpositivity": "8.21%",
        "totalcumtests": 23234,
        "total2weektests": 2412
    },
    {
        "id": "Avon",
        "totalcumtests": 5418,
        "total2weektests": 665,
        "adir": 120.8,
        "totalpositivetests": 89,
        "casecount": 74,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 338,
        "percentpositivity": "13.38%"
    },
    {
        "id": "Ayer",
        "totalpositivetests": 105,
        "datepublished": "01/21/2021",
        "adir": 82,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 13771,
        "total2weektests": 1134,
        "totalcasecount": 630,
        "casecount": 93,
        "percentpositivity": "9.26%"
    },
    {
        "id": "Barnstable",
        "datepublished": "01/21/2021",
        "total2weektests": 5413,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 2320,
        "totalcumtests": 46698,
        "percentpositivity": "8.09%",
        "adir": 64.9,
        "totalpositivetests": 438,
        "casecount": 407
    },
    {
        "id": "Barre",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.45%",
        "datepublished": "01/21/2021",
        "casecount": 32,
        "totalcasecount": 191,
        "total2weektests": 537,
        "adir": 41.1,
        "totalpositivetests": 40,
        "totalcumtests": 5302
    },
    {
        "id": "Becket",
        "total2weektests": 220,
        "totalcasecount": 43,
        "percentpositivity": "5.45%",
        "datepublished": "01/21/2021",
        "casecount": 10,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 1775,
        "adir": 39.8,
        "totalpositivetests": 12
    },
    {
        "id": "Bedford",
        "datepublished": "01/21/2021",
        "totalcasecount": 645,
        "percentpositivity": "4.23%",
        "casecount": 126,
        "totalpositivetests": 135,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 26461,
        "adir": 60,
        "total2weektests": 3190
    },
    {
        "id": "Belchertown",
        "datepublished": "01/21/2021",
        "totalcasecount": 557,
        "percentpositivity": "5.75%",
        "adir": 46.3,
        "total2weektests": 2087,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 120,
        "totalcumtests": 21631,
        "casecount": 104
    },
    {
        "id": "Bellingham",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 111,
        "casecount": 102,
        "percentpositivity": "8.33%",
        "totalcumtests": 15579,
        "totalcasecount": 731,
        "adir": 40.4,
        "datepublished": "01/21/2021",
        "total2weektests": 1332
    },
    {
        "id": "Belmont",
        "totalcumtests": 43709,
        "totalpositivetests": 168,
        "totalcasecount": 847,
        "percentpositivity": "3.01%",
        "casecount": 143,
        "datepublished": "01/21/2021",
        "adir": 37.3,
        "total2weektests": 5577,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Berkley",
        "total2weektests": 779,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 90,
        "datepublished": "01/21/2021",
        "totalpositivetests": 104,
        "adir": 94.3,
        "percentpositivity": "13.35%",
        "totalcumtests": 7502,
        "totalcasecount": 477
    },
    {
        "id": "Berlin",
        "total2weektests": 454,
        "adir": 62,
        "percentpositivity": "7.05%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 129,
        "totalcumtests": 3993,
        "datepublished": "01/21/2021",
        "totalpositivetests": 32,
        "casecount": 28
    },
    {
        "id": "Bernardston",
        "casecount": "<5",
        "totalpositivetests": 4,
        "datepublished": "01/21/2021",
        "totalcumtests": 2617,
        "totalcasecount": 34,
        "total2weektests": 248,
        "percentpositivity": "1.61%",
        "adir": 13.8,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Beverly",
        "datepublished": "01/21/2021",
        "totalcumtests": 95228,
        "adir": 71.3,
        "totalpositivetests": 481,
        "totalcasecount": 2492,
        "percentpositivity": "6.10%",
        "total2weektests": 7881,
        "casecount": 410,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Billerica",
        "total2weektests": 5717,
        "datepublished": "01/21/2021",
        "casecount": 418,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 473,
        "adir": 68.4,
        "totalcumtests": 52675,
        "totalcasecount": 2727,
        "percentpositivity": "8.27%"
    },
    {
        "id": "Blackstone",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 65,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.97%",
        "adir": 49.9,
        "totalcumtests": 8363,
        "casecount": 63,
        "totalcasecount": 396,
        "total2weektests": 725
    },
    {
        "id": "Blandford",
        "totalcasecount": 33,
        "casecount": "<5",
        "percentpositivity": "2.38%",
        "adir": 17.7,
        "total2weektests": 126,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 3,
        "datepublished": "01/21/2021",
        "totalcumtests": 991
    },
    {
        "id": "Bolton",
        "casecount": 21,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 756,
        "totalcumtests": 6986,
        "totalpositivetests": 23,
        "totalcasecount": 118,
        "percentpositivity": "3.04%",
        "adir": 29.7
    },
    {
        "id": "Boston",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 49256,
        "totalcumtests": 2105010,
        "casecount": 6954,
        "percentpositivity": "4.60%",
        "datepublished": "01/21/2021",
        "adir": 71.7,
        "totalpositivetests": 7868,
        "total2weektests": 171060
    },
    {
        "id": "Bourne",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 25508,
        "totalpositivetests": 150,
        "casecount": 140,
        "total2weektests": 2948,
        "datepublished": "01/21/2021",
        "percentpositivity": "5.09%",
        "adir": 47.6,
        "totalcasecount": 773
    },
    {
        "id": "Boxborough",
        "totalcasecount": 132,
        "adir": 36.6,
        "totalpositivetests": 27,
        "datepublished": "01/21/2021",
        "casecount": 26,
        "totalcumtests": 5709,
        "total2weektests": 590,
        "percentpositivity": "4.58%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Boxford",
        "totalpositivetests": 79,
        "percentpositivity": "6.83%",
        "datepublished": "01/21/2021",
        "casecount": 72,
        "total2weektests": 1157,
        "totalcasecount": 370,
        "adir": 67.3,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 11033
    },
    {
        "id": "Boylston",
        "datepublished": "01/21/2021",
        "total2weektests": 673,
        "totalcasecount": 207,
        "casecount": 37,
        "totalpositivetests": 38,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 58.9,
        "totalcumtests": 6100,
        "percentpositivity": "5.65%"
    },
    {
        "id": "Braintree",
        "totalpositivetests": 597,
        "adir": 95.3,
        "totalcasecount": 2864,
        "casecount": 529,
        "total2weektests": 7239,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.25%",
        "totalcumtests": 61343,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Brewster",
        "totalpositivetests": 44,
        "totalcasecount": 264,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 39,
        "totalcumtests": 11353,
        "adir": 28.1,
        "percentpositivity": "2.72%",
        "total2weektests": 1618,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Bridgewater",
        "percentpositivity": "12.24%",
        "totalpositivetests": 409,
        "casecount": 360,
        "adir": 89.9,
        "totalcasecount": 1867,
        "total2weektests": 3342,
        "totalcumtests": 43832,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Brimfield",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 59.4,
        "total2weektests": 420,
        "casecount": 31,
        "percentpositivity": "7.38%",
        "totalcasecount": 128,
        "datepublished": "01/21/2021",
        "totalpositivetests": 31,
        "totalcumtests": 3588
    },
    {
        "id": "Brockton",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 1488,
        "totalcumtests": 135734,
        "total2weektests": 13791,
        "datepublished": "01/21/2021",
        "totalcasecount": 10330,
        "percentpositivity": "10.79%",
        "adir": 95.7,
        "casecount": 1330
    },
    {
        "id": "Brookfield",
        "datepublished": "01/21/2021",
        "adir": 52.3,
        "totalpositivetests": 32,
        "totalcasecount": 153,
        "casecount": 27,
        "totalcumtests": 3548,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.67%",
        "total2weektests": 369
    },
    {
        "id": "Brookline",
        "totalcumtests": 131013,
        "casecount": 248,
        "datepublished": "01/21/2021",
        "percentpositivity": "2.31%",
        "totalcasecount": 1562,
        "adir": 27.4,
        "total2weektests": 12565,
        "totalpositivetests": 290,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Buckland",
        "datepublished": "01/21/2021",
        "total2weektests": 31,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 15.5,
        "totalcasecount": 29,
        "totalcumtests": 301,
        "totalpositivetests": 4,
        "casecount": "<5",
        "percentpositivity": "12.90%"
    },
    {
        "id": "Burlington",
        "total2weektests": 3811,
        "totalpositivetests": 249,
        "percentpositivity": "6.53%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 33219,
        "casecount": 228,
        "totalcasecount": 1354,
        "adir": 58.5,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Cambridge",
        "totalpositivetests": 663,
        "percentpositivity": "1.49%",
        "casecount": 554,
        "totalcumtests": 494699,
        "totalcasecount": 3618,
        "total2weektests": 44470,
        "datepublished": "01/21/2021",
        "adir": 35.3,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Canton",
        "adir": 87.8,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 285,
        "totalcasecount": 1236,
        "percentpositivity": "7.20%",
        "total2weektests": 4109,
        "totalpositivetests": 296,
        "totalcumtests": 36869
    },
    {
        "id": "Carlisle",
        "totalcasecount": 119,
        "totalpositivetests": 19,
        "datepublished": "01/21/2021",
        "total2weektests": 644,
        "percentpositivity": "2.95%",
        "adir": 24.2,
        "casecount": 16,
        "totalcumtests": 5896,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Carver",
        "casecount": 98,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 106,
        "totalcumtests": 10184,
        "adir": 57.2,
        "totalcasecount": 450,
        "total2weektests": 1208,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.77%"
    },
    {
        "id": "Charlemont",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 8,
        "totalcasecount": 15,
        "percentpositivity": "5.56%",
        "totalpositivetests": 8,
        "totalcumtests": 1302,
        "total2weektests": 144,
        "adir": 48.7,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Charlton",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "5.63%",
        "totalcumtests": 18814,
        "casecount": 104,
        "totalcasecount": 668,
        "adir": 52.4,
        "total2weektests": 2112,
        "totalpositivetests": 119,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Chatham",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 575,
        "totalcumtests": 6032,
        "totalcasecount": 167,
        "percentpositivity": "10.96%",
        "casecount": 54,
        "totalpositivetests": 63,
        "adir": 66.2
    },
    {
        "id": "Chelmsford",
        "totalpositivetests": 353,
        "percentpositivity": "7.89%",
        "total2weektests": 4472,
        "casecount": 328,
        "adir": 65.1,
        "datepublished": "01/21/2021",
        "totalcumtests": 45349,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 2012
    },
    {
        "id": "Chelsea",
        "totalcumtests": 86736,
        "datepublished": "01/21/2021",
        "total2weektests": 9357,
        "percentpositivity": "9.67%",
        "totalcasecount": 7209,
        "totalpositivetests": 905,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 142.6,
        "casecount": 737
    },
    {
        "id": "Cheshire",
        "percentpositivity": "6.28%",
        "total2weektests": 398,
        "datepublished": "01/21/2021",
        "totalcumtests": 3310,
        "adir": 53.5,
        "totalpositivetests": 25,
        "casecount": 22,
        "totalcasecount": 81,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Chester",
        "percentpositivity": "16.79%",
        "totalcasecount": 38,
        "datepublished": "01/21/2021",
        "total2weektests": 131,
        "adir": 94.7,
        "casecount": 18,
        "totalpositivetests": 22,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 969
    },
    {
        "id": "Chesterfield",
        "totalpositivetests": 7,
        "adir": 40.9,
        "casecount": 7,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 119,
        "datepublished": "01/21/2021",
        "totalcumtests": 1044,
        "totalcasecount": 25,
        "percentpositivity": "5.88%"
    },
    {
        "id": "Chicopee",
        "adir": 90.7,
        "percentpositivity": "10.89%",
        "datepublished": "01/21/2021",
        "total2weektests": 8152,
        "totalcumtests": 70388,
        "totalpositivetests": 888,
        "totalcasecount": 3706,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 720
    },
    {
        "id": "Chilmark",
        "percentpositivity": "0.90%",
        "totalcasecount": 12,
        "totalpositivetests": 2,
        "total2weektests": 223,
        "adir": 18.8,
        "datepublished": "01/21/2021",
        "totalcumtests": 2911,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Clarksburg",
        "total2weektests": 151,
        "datepublished": "01/21/2021",
        "totalcasecount": 31,
        "totalpositivetests": 6,
        "adir": 25.6,
        "percentpositivity": "3.97%",
        "totalcumtests": 1237,
        "casecount": 6,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Clinton",
        "totalcumtests": 17103,
        "totalcasecount": 1164,
        "adir": 113.6,
        "datepublished": "01/21/2021",
        "total2weektests": 1902,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "13.20%",
        "casecount": 224,
        "totalpositivetests": 251
    },
    {
        "id": "Cohasset",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 63.1,
        "totalpositivetests": 68,
        "casecount": 65,
        "datepublished": "01/21/2021",
        "percentpositivity": "4.77%",
        "totalcumtests": 10042,
        "total2weektests": 1427,
        "totalcasecount": 252
    },
    {
        "id": "Colrain",
        "datepublished": "01/21/2021",
        "total2weektests": 173,
        "casecount": 5,
        "totalcumtests": 1578,
        "totalpositivetests": 5,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 22.6,
        "totalcasecount": 22,
        "percentpositivity": "2.89%"
    },
    {
        "id": "Concord",
        "casecount": 114,
        "percentpositivity": "3.13%",
        "total2weektests": 4061,
        "totalpositivetests": 127,
        "totalcumtests": 33333,
        "adir": 43.5,
        "totalcasecount": 815,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Conway",
        "totalcumtests": 1965,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 6,
        "total2weektests": 177,
        "adir": 22.2,
        "datepublished": "01/21/2021",
        "totalcasecount": 21,
        "percentpositivity": "3.95%",
        "totalpositivetests": 7
    },
    {
        "id": "Cummington",
        "totalpositivetests": 1,
        "total2weektests": 108,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 1152,
        "datepublished": "01/21/2021",
        "totalcasecount": 18,
        "percentpositivity": "0.93%",
        "adir": 9.1
    },
    {
        "id": "Dalton",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 58,
        "casecount": 56,
        "percentpositivity": "3.93%",
        "adir": 61.9,
        "datepublished": "01/21/2021",
        "total2weektests": 1476,
        "totalcasecount": 179,
        "totalcumtests": 8619
    },
    {
        "id": "Danvers",
        "totalpositivetests": 346,
        "totalcasecount": 2305,
        "adir": 77.2,
        "total2weektests": 5538,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "6.25%",
        "totalcumtests": 48687,
        "casecount": 310
    },
    {
        "id": "Dartmouth",
        "total2weektests": 5264,
        "totalpositivetests": 556,
        "totalcasecount": 2676,
        "totalcumtests": 49979,
        "adir": 97,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 504,
        "percentpositivity": "10.56%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Dedham",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 43770,
        "totalcasecount": 1518,
        "datepublished": "01/21/2021",
        "adir": 71.5,
        "percentpositivity": "6.41%",
        "casecount": 274,
        "total2weektests": 4773,
        "totalpositivetests": 306
    },
    {
        "id": "Deerfield",
        "adir": 43.1,
        "datepublished": "01/21/2021",
        "percentpositivity": "1.16%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 3009,
        "totalcumtests": 19854,
        "totalcasecount": 127,
        "casecount": 32,
        "totalpositivetests": 35
    },
    {
        "id": "Dennis",
        "percentpositivity": "6.61%",
        "totalcumtests": 12097,
        "casecount": 85,
        "totalcasecount": 425,
        "totalpositivetests": 97,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 46.4,
        "total2weektests": 1467
    },
    {
        "id": "Dighton",
        "totalcasecount": 519,
        "totalpositivetests": 110,
        "adir": 92.8,
        "totalcumtests": 8387,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 884,
        "datepublished": "01/21/2021",
        "casecount": 103,
        "percentpositivity": "12.44%"
    },
    {
        "id": "Douglas",
        "datepublished": "01/21/2021",
        "totalcasecount": 325,
        "totalcumtests": 8258,
        "totalpositivetests": 44,
        "adir": 32.4,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "5.90%",
        "total2weektests": 746,
        "casecount": 43
    },
    {
        "id": "Dover",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 8687,
        "totalpositivetests": 45,
        "casecount": 42,
        "totalcasecount": 167,
        "total2weektests": 1117,
        "datepublished": "01/21/2021",
        "adir": 58.4,
        "percentpositivity": "4.03%"
    },
    {
        "id": "Dracut",
        "casecount": 349,
        "percentpositivity": "9.24%",
        "total2weektests": 4350,
        "totalcasecount": 2599,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 42106,
        "totalpositivetests": 402,
        "datepublished": "01/21/2021",
        "adir": 76.9
    },
    {
        "id": "Dudley",
        "percentpositivity": "9.85%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 615,
        "casecount": 123,
        "totalcumtests": 28964,
        "total2weektests": 1309,
        "adir": 70.5,
        "totalpositivetests": 129
    },
    {
        "id": "Dunstable",
        "totalcumtests": 3140,
        "total2weektests": 323,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 45,
        "datepublished": "01/21/2021",
        "totalpositivetests": 22,
        "casecount": 21,
        "totalcasecount": 108,
        "percentpositivity": "6.81%"
    },
    {
        "id": "Duxbury",
        "datepublished": "01/21/2021",
        "percentpositivity": "6.69%",
        "totalcumtests": 19615,
        "casecount": 166,
        "totalpositivetests": 177,
        "total2weektests": 2645,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 78.4,
        "totalcasecount": 634
    },
    {
        "id": "East Bridgewater",
        "datepublished": "01/21/2021",
        "total2weektests": 2031,
        "totalcumtests": 15152,
        "casecount": 179,
        "adir": 85.9,
        "totalpositivetests": 201,
        "totalcasecount": 837,
        "percentpositivity": "9.90%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "East Brookfield",
        "percentpositivity": "12.56%",
        "totalcumtests": 2121,
        "totalcasecount": 109,
        "casecount": 26,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 223,
        "datepublished": "01/21/2021",
        "totalpositivetests": 28,
        "adir": 82.8
    },
    {
        "id": "East Longmeadow",
        "totalcumtests": 25160,
        "percentpositivity": "7.11%",
        "adir": 75.2,
        "datepublished": "01/21/2021",
        "total2weektests": 2786,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 198,
        "totalcasecount": 1117,
        "casecount": 179
    },
    {
        "id": "Eastham",
        "total2weektests": 283,
        "totalpositivetests": 13,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "4.59%",
        "datepublished": "01/21/2021",
        "totalcasecount": 65,
        "adir": 20.2,
        "totalcumtests": 3248,
        "casecount": 13
    },
    {
        "id": "Easthampton",
        "adir": 75,
        "datepublished": "01/21/2021",
        "total2weektests": 4334,
        "totalpositivetests": 189,
        "percentpositivity": "4.36%",
        "totalcumtests": 35173,
        "casecount": 170,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 642
    },
    {
        "id": "Easton",
        "adir": 76.1,
        "total2weektests": 3736,
        "totalcumtests": 58843,
        "totalcasecount": 1279,
        "casecount": 253,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 294,
        "percentpositivity": "7.87%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Edgartown",
        "adir": 103.1,
        "totalcumtests": 8930,
        "totalpositivetests": 62,
        "total2weektests": 749,
        "percentpositivity": "8.28%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 210,
        "casecount": 59,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Egremont",
        "casecount": "<5",
        "adir": 13.3,
        "percentpositivity": "2.15%",
        "totalcumtests": 940,
        "total2weektests": 93,
        "datepublished": "01/21/2021",
        "totalpositivetests": 2,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 11
    },
    {
        "id": "Erving",
        "datepublished": "01/21/2021",
        "casecount": 14,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 198,
        "percentpositivity": "7.07%",
        "totalcasecount": 46,
        "adir": 47.3,
        "totalcumtests": 2066,
        "totalpositivetests": 14
    },
    {
        "id": "Essex",
        "totalpositivetests": 26,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 3649,
        "totalcasecount": 116,
        "adir": 46,
        "casecount": 24,
        "datepublished": "01/21/2021",
        "percentpositivity": "5.83%",
        "total2weektests": 446
    },
    {
        "id": "Everett",
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 1286,
        "totalcumtests": 81234,
        "adir": 158.9,
        "casecount": 1080,
        "total2weektests": 9625,
        "percentpositivity": "13.36%",
        "totalcasecount": 6681
    },
    {
        "id": "Fairhaven",
        "total2weektests": 3727,
        "datepublished": "01/21/2021",
        "adir": 149,
        "percentpositivity": "10.36%",
        "casecount": 334,
        "totalcumtests": 27181,
        "totalcasecount": 1453,
        "totalpositivetests": 386,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Fall River",
        "percentpositivity": "13.19%",
        "totalpositivetests": 2059,
        "casecount": 1791,
        "adir": 143.2,
        "total2weektests": 15613,
        "totalcasecount": 10429,
        "datepublished": "01/21/2021",
        "totalcumtests": 131557,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Falmouth",
        "casecount": 190,
        "adir": 43.5,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 3600,
        "datepublished": "01/21/2021",
        "totalcasecount": 942,
        "totalcumtests": 40502,
        "totalpositivetests": 209,
        "percentpositivity": "5.81%"
    },
    {
        "id": "Fitchburg",
        "percentpositivity": "10.34%",
        "totalpositivetests": 548,
        "adir": 85.8,
        "totalcumtests": 53546,
        "total2weektests": 5301,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 506,
        "datepublished": "01/21/2021",
        "totalcasecount": 3480
    },
    {
        "id": "Florida",
        "percentpositivity": "2.78%",
        "total2weektests": 36,
        "totalcumtests": 444,
        "adir": 9.1,
        "totalpositivetests": 1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 6,
        "casecount": "<5",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Foxborough",
        "totalpositivetests": 171,
        "datepublished": "01/21/2021",
        "adir": 62,
        "casecount": 158,
        "totalcumtests": 34865,
        "total2weektests": 2437,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.02%",
        "totalcasecount": 822
    },
    {
        "id": "Framingham",
        "datepublished": "01/21/2021",
        "total2weektests": 11486,
        "totalcumtests": 110905,
        "totalpositivetests": 727,
        "adir": 60.7,
        "percentpositivity": "6.33%",
        "totalcasecount": 5910,
        "casecount": 632,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Franklin",
        "total2weektests": 3323,
        "totalcasecount": 1135,
        "percentpositivity": "6.77%",
        "adir": 43,
        "totalpositivetests": 225,
        "datepublished": "01/21/2021",
        "casecount": 204,
        "totalcumtests": 34361,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Freetown",
        "totalcumtests": 10137,
        "datepublished": "01/21/2021",
        "adir": 107.3,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 669,
        "percentpositivity": "13.16%",
        "totalpositivetests": 155,
        "casecount": 136,
        "total2weektests": 1178
    },
    {
        "id": "Gardner",
        "datepublished": "01/21/2021",
        "adir": 139.8,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "15.16%",
        "totalcasecount": 1640,
        "total2weektests": 2791,
        "totalpositivetests": 423,
        "totalcumtests": 27163,
        "casecount": 389
    },
    {
        "id": "Georgetown",
        "totalcasecount": 380,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 10063,
        "total2weektests": 1154,
        "casecount": 70,
        "adir": 55.6,
        "percentpositivity": "6.50%",
        "totalpositivetests": 75
    },
    {
        "id": "Gill",
        "percentpositivity": "4.79%",
        "adir": 34.2,
        "totalcasecount": 26,
        "totalcumtests": 3115,
        "total2weektests": 167,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 8,
        "casecount": 8
    },
    {
        "id": "Gloucester",
        "totalpositivetests": 329,
        "total2weektests": 4070,
        "totalcasecount": 1303,
        "adir": 75.7,
        "totalcumtests": 32927,
        "percentpositivity": "8.08%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 301
    },
    {
        "id": "Goshen",
        "casecount": "<5",
        "totalcasecount": 15,
        "adir": 12.4,
        "percentpositivity": "2.90%",
        "datepublished": "01/21/2021",
        "total2weektests": 69,
        "totalpositivetests": 2,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 577
    },
    {
        "id": "Gosnold",
        "totalcasecount": 5,
        "percentpositivity": "0%",
        "totalcumtests": 118,
        "totalpositivetests": 0,
        "casecount": 0,
        "total2weektests": 3,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 0
    },
    {
        "id": "Grafton",
        "totalpositivetests": 202,
        "casecount": 186,
        "total2weektests": 2959,
        "adir": 66,
        "datepublished": "01/21/2021",
        "totalcumtests": 26257,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 797,
        "percentpositivity": "6.83%"
    },
    {
        "id": "Granby",
        "totalpositivetests": 53,
        "percentpositivity": "6.42%",
        "totalcumtests": 7823,
        "adir": 58.4,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 234,
        "casecount": 50,
        "total2weektests": 825
    },
    {
        "id": "Granville",
        "total2weektests": 137,
        "casecount": 9,
        "totalpositivetests": 9,
        "datepublished": "01/21/2021",
        "totalcumtests": 1495,
        "totalcasecount": 60,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "6.57%",
        "adir": 41.5
    },
    {
        "id": "Great Barrington",
        "totalcumtests": 17886,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "6.46%",
        "totalpositivetests": 117,
        "total2weektests": 1811,
        "totalcasecount": 303,
        "adir": 119,
        "casecount": 112
    },
    {
        "id": "Greenfield",
        "totalcumtests": 23841,
        "casecount": 66,
        "datepublished": "01/21/2021",
        "percentpositivity": "3.17%",
        "totalcasecount": 595,
        "adir": 27.5,
        "total2weektests": 2366,
        "totalpositivetests": 75,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Groton",
        "datepublished": "01/21/2021",
        "totalcumtests": 16432,
        "casecount": 47,
        "percentpositivity": "2.58%",
        "total2weektests": 1976,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 306,
        "adir": 28.7,
        "totalpositivetests": 51
    },
    {
        "id": "Groveland",
        "adir": 73,
        "totalpositivetests": 81,
        "percentpositivity": "10.10%",
        "total2weektests": 802,
        "casecount": 70,
        "totalcasecount": 353,
        "totalcumtests": 7722,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Hadley",
        "adir": 59.1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 1072,
        "percentpositivity": "4.85%",
        "totalcumtests": 15262,
        "datepublished": "01/21/2021",
        "totalpositivetests": 52,
        "casecount": 48,
        "totalcasecount": 207
    },
    {
        "id": "Halifax",
        "adir": 59.8,
        "percentpositivity": "8.14%",
        "totalcasecount": 335,
        "total2weektests": 848,
        "totalcumtests": 7424,
        "casecount": 64,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 69,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Hamilton",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "5.67%",
        "casecount": 78,
        "adir": 75.5,
        "totalcumtests": 10378,
        "datepublished": "01/21/2021",
        "totalcasecount": 255,
        "totalpositivetests": 91,
        "total2weektests": 1606
    },
    {
        "id": "Hampden",
        "totalcumtests": 7199,
        "totalcasecount": 296,
        "total2weektests": 878,
        "datepublished": "01/21/2021",
        "adir": 65.6,
        "percentpositivity": "5.47%",
        "casecount": 45,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 48
    },
    {
        "id": "Hancock",
        "casecount": 0,
        "totalcasecount": 12,
        "total2weektests": 18,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "0%",
        "totalpositivetests": 0,
        "adir": 0,
        "datepublished": "01/21/2021",
        "totalcumtests": 194
    },
    {
        "id": "Hanover",
        "datepublished": "01/21/2021",
        "adir": 84.4,
        "total2weektests": 2165,
        "totalcumtests": 16063,
        "casecount": 170,
        "percentpositivity": "8.73%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 189,
        "totalcasecount": 872
    },
    {
        "id": "Hanson",
        "totalpositivetests": 137,
        "datepublished": "01/21/2021",
        "percentpositivity": "10.13%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 118,
        "adir": 78.3,
        "totalcumtests": 11279,
        "totalcasecount": 589,
        "total2weektests": 1353
    },
    {
        "id": "Hardwick",
        "totalcumtests": 2310,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "3.95%",
        "totalpositivetests": 10,
        "casecount": 10,
        "totalcasecount": 55,
        "total2weektests": 253,
        "adir": 21.4,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Harvard",
        "percentpositivity": "3.10%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "adir": 15.4,
        "total2weektests": 549,
        "totalpositivetests": 17,
        "casecount": 15,
        "totalcasecount": 90,
        "totalcumtests": 6023
    },
    {
        "id": "Harwich",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 53.9,
        "totalcumtests": 12441,
        "casecount": 95,
        "totalpositivetests": 108,
        "datepublished": "01/21/2021",
        "percentpositivity": "7.52%",
        "total2weektests": 1436,
        "totalcasecount": 447
    },
    {
        "id": "Hatfield",
        "totalcasecount": 103,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 66.2,
        "total2weektests": 463,
        "totalpositivetests": 38,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.21%",
        "totalcumtests": 4339,
        "casecount": 30
    },
    {
        "id": "Haverhill",
        "totalcumtests": 100950,
        "total2weektests": 10817,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "10.40%",
        "totalcasecount": 5947,
        "datepublished": "01/21/2021",
        "adir": 106.6,
        "casecount": 984,
        "totalpositivetests": 1125
    },
    {
        "id": "Hawley",
        "totalpositivetests": 0,
        "totalcasecount": 0,
        "datepublished": "01/21/2021",
        "casecount": 0,
        "percentpositivity": "0%",
        "total2weektests": 7,
        "totalcumtests": 90,
        "adir": 0,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Heath",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 49,
        "totalpositivetests": 2,
        "adir": 24.3,
        "totalcasecount": 7,
        "percentpositivity": "4.08%",
        "totalcumtests": 444,
        "datepublished": "01/21/2021",
        "casecount": "<5"
    },
    {
        "id": "Hingham",
        "adir": 64,
        "total2weektests": 5311,
        "totalcasecount": 1242,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 239,
        "casecount": 215,
        "totalcumtests": 37464,
        "percentpositivity": "4.50%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Hinsdale",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "5.96%",
        "casecount": 17,
        "datepublished": "01/21/2021",
        "adir": 57.1,
        "totalpositivetests": 19,
        "totalcumtests": 2355,
        "total2weektests": 319,
        "totalcasecount": 43
    },
    {
        "id": "Holbrook",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 100.8,
        "percentpositivity": "11.58%",
        "casecount": 160,
        "totalcumtests": 13044,
        "totalcasecount": 749,
        "totalpositivetests": 178,
        "datepublished": "01/21/2021",
        "total2weektests": 1537
    },
    {
        "id": "Holden",
        "adir": 76.3,
        "totalpositivetests": 222,
        "totalcumtests": 27565,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.92%",
        "totalcasecount": 1014,
        "casecount": 203,
        "total2weektests": 2803
    },
    {
        "id": "Holland",
        "percentpositivity": "6.64%",
        "total2weektests": 241,
        "totalcumtests": 2310,
        "casecount": 16,
        "totalcasecount": 81,
        "totalpositivetests": 16,
        "datepublished": "01/21/2021",
        "adir": 44.6,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Holliston",
        "total2weektests": 1881,
        "totalpositivetests": 98,
        "adir": 48.4,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 536,
        "datepublished": "01/21/2021",
        "totalcumtests": 17874,
        "casecount": 93,
        "percentpositivity": "5.21%"
    },
    {
        "id": "Holyoke",
        "totalpositivetests": 716,
        "totalcumtests": 70913,
        "total2weektests": 8500,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 104.4,
        "casecount": 594,
        "percentpositivity": "8.42%",
        "datepublished": "01/21/2021",
        "totalcasecount": 3774
    },
    {
        "id": "Hopedale",
        "totalpositivetests": 37,
        "percentpositivity": "4.71%",
        "adir": 43.1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 239,
        "total2weektests": 785,
        "totalcumtests": 7427,
        "casecount": 34
    },
    {
        "id": "Hopkinton",
        "totalcasecount": 542,
        "percentpositivity": "4.92%",
        "totalcumtests": 21566,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 2215,
        "adir": 43.2,
        "totalpositivetests": 109,
        "casecount": 99
    },
    {
        "id": "Hubbardston",
        "totalcasecount": 102,
        "percentpositivity": "5.71%",
        "adir": 38.2,
        "datepublished": "01/21/2021",
        "totalcumtests": 4499,
        "casecount": 25,
        "totalpositivetests": 25,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 438
    },
    {
        "id": "Hudson",
        "percentpositivity": "8.25%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 201,
        "adir": 68.2,
        "totalpositivetests": 218,
        "totalcasecount": 1159,
        "datepublished": "01/21/2021",
        "totalcumtests": 24636,
        "total2weektests": 2642
    },
    {
        "id": "Hull",
        "totalcasecount": 372,
        "percentpositivity": "8.39%",
        "totalpositivetests": 107,
        "adir": 72.2,
        "total2weektests": 1275,
        "totalcumtests": 9981,
        "datepublished": "01/21/2021",
        "casecount": 99,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Huntington",
        "totalcumtests": 2282,
        "casecount": 14,
        "percentpositivity": "7.23%",
        "datepublished": "01/21/2021",
        "adir": 45.5,
        "totalpositivetests": 18,
        "totalcasecount": 67,
        "total2weektests": 249,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Ipswich",
        "adir": 63.9,
        "total2weektests": 2021,
        "totalcasecount": 513,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 120,
        "percentpositivity": "6.98%",
        "totalcumtests": 16637,
        "datepublished": "01/21/2021",
        "totalpositivetests": 141
    },
    {
        "id": "Kingston",
        "datepublished": "01/21/2021",
        "totalcumtests": 18872,
        "totalpositivetests": 212,
        "casecount": 192,
        "percentpositivity": "8.27%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 737,
        "total2weektests": 2565,
        "adir": 100.3
    },
    {
        "id": "Lakeville",
        "totalcasecount": 611,
        "total2weektests": 1536,
        "percentpositivity": "10.55%",
        "casecount": 149,
        "adir": 93.6,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 162,
        "datepublished": "01/21/2021",
        "totalcumtests": 12108
    },
    {
        "id": "Lancaster",
        "totalpositivetests": 63,
        "datepublished": "01/21/2021",
        "adir": 45.7,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 380,
        "total2weektests": 1099,
        "casecount": 55,
        "percentpositivity": "5.73%",
        "totalcumtests": 9766
    },
    {
        "id": "Lanesborough",
        "adir": 28.3,
        "totalpositivetests": 12,
        "totalcumtests": 3123,
        "total2weektests": 356,
        "casecount": 12,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "3.37%",
        "totalcasecount": 80
    },
    {
        "id": "Lawrence",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "15.29%",
        "adir": 160.9,
        "totalpositivetests": 2577,
        "totalcumtests": 154986,
        "total2weektests": 16850,
        "totalcasecount": 16055,
        "datepublished": "01/21/2021",
        "casecount": 1976
    },
    {
        "id": "Lee",
        "casecount": 52,
        "datepublished": "01/21/2021",
        "totalcumtests": 7122,
        "totalpositivetests": 55,
        "adir": 63.7,
        "percentpositivity": "5.94%",
        "total2weektests": 926,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 229
    },
    {
        "id": "Leicester",
        "totalcasecount": 725,
        "casecount": 107,
        "percentpositivity": "6.55%",
        "totalcumtests": 15607,
        "adir": 67.9,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 1786,
        "datepublished": "01/21/2021",
        "totalpositivetests": 117
    },
    {
        "id": "Lenox",
        "adir": 26.6,
        "casecount": 18,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 23,
        "total2weektests": 848,
        "totalcumtests": 8810,
        "totalcasecount": 160,
        "percentpositivity": "2.71%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Leominster",
        "totalpositivetests": 698,
        "adir": 115.9,
        "datepublished": "01/21/2021",
        "totalcumtests": 55142,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 3734,
        "total2weektests": 5674,
        "percentpositivity": "12.30%",
        "casecount": 655
    },
    {
        "id": "Leverett",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 230,
        "datepublished": "01/21/2021",
        "totalpositivetests": 4,
        "totalcasecount": 24,
        "percentpositivity": "1.74%",
        "totalcumtests": 3381,
        "adir": 10.6,
        "casecount": "<5"
    },
    {
        "id": "Lexington",
        "datepublished": "01/21/2021",
        "percentpositivity": "2.37%",
        "totalcasecount": 857,
        "casecount": 101,
        "totalcumtests": 42279,
        "adir": 21.2,
        "total2weektests": 4935,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 117
    },
    {
        "id": "Leyden",
        "casecount": 0,
        "adir": 0,
        "totalcasecount": "<5",
        "percentpositivity": "0%",
        "total2weektests": 18,
        "totalpositivetests": 0,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 199
    },
    {
        "id": "Lincoln",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 907,
        "adir": 14.8,
        "totalcasecount": 138,
        "totalpositivetests": 22,
        "percentpositivity": "2.43%",
        "datepublished": "01/21/2021",
        "casecount": 18,
        "totalcumtests": 8741
    },
    {
        "id": "Littleton",
        "percentpositivity": "4.56%",
        "totalpositivetests": 63,
        "totalcasecount": 384,
        "totalcumtests": 12699,
        "casecount": 59,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "adir": 43.2,
        "total2weektests": 1381
    },
    {
        "id": "Longmeadow",
        "datepublished": "01/21/2021",
        "adir": 53.3,
        "totalcasecount": 816,
        "casecount": 115,
        "totalcumtests": 25320,
        "totalpositivetests": 131,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "4.87%",
        "total2weektests": 2691
    },
    {
        "id": "Lowell",
        "percentpositivity": "10.15%",
        "datepublished": "01/21/2021",
        "totalcasecount": 12483,
        "totalpositivetests": 1598,
        "casecount": 1415,
        "totalcumtests": 174976,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 87,
        "total2weektests": 15749
    },
    {
        "id": "Ludlow",
        "datepublished": "01/21/2021",
        "totalpositivetests": 346,
        "totalcasecount": 1465,
        "total2weektests": 3026,
        "percentpositivity": "11.43%",
        "adir": 97.6,
        "totalcumtests": 27871,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 283
    },
    {
        "id": "Lunenburg",
        "totalcumtests": 11405,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "9.29%",
        "adir": 63.8,
        "casecount": 93,
        "total2weektests": 1119,
        "totalcasecount": 495,
        "totalpositivetests": 104
    },
    {
        "id": "Lynn",
        "totalcasecount": 13429,
        "totalcumtests": 150990,
        "adir": 127.2,
        "totalpositivetests": 2130,
        "datepublished": "01/21/2021",
        "percentpositivity": "12.87%",
        "casecount": 1795,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 16552
    },
    {
        "id": "Lynnfield",
        "adir": 56.7,
        "totalcasecount": 840,
        "totalpositivetests": 114,
        "datepublished": "01/21/2021",
        "casecount": 92,
        "totalcumtests": 19803,
        "percentpositivity": "5.15%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 2214
    },
    {
        "id": "Malden",
        "casecount": 823,
        "datepublished": "01/21/2021",
        "totalcasecount": 5162,
        "totalcumtests": 100628,
        "total2weektests": 11179,
        "adir": 86.9,
        "totalpositivetests": 987,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.83%"
    },
    {
        "id": "Manchester",
        "percentpositivity": "4.34%",
        "total2weektests": 875,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 38,
        "totalcumtests": 7210,
        "totalcasecount": 164,
        "casecount": 34,
        "datepublished": "01/21/2021",
        "adir": 49.6
    },
    {
        "id": "Mansfield",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 58.9,
        "total2weektests": 2846,
        "percentpositivity": "7.27%",
        "totalcasecount": 1102,
        "totalpositivetests": 207,
        "casecount": 195,
        "datepublished": "01/21/2021",
        "totalcumtests": 27946
    },
    {
        "id": "Marblehead",
        "totalcumtests": 30948,
        "casecount": 146,
        "datepublished": "01/21/2021",
        "adir": 54.8,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 905,
        "total2weektests": 4098,
        "percentpositivity": "4.25%",
        "totalpositivetests": 174
    },
    {
        "id": "Marion",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 86,
        "percentpositivity": "9.67%",
        "datepublished": "01/21/2021",
        "adir": 133.6,
        "total2weektests": 951,
        "totalcasecount": 297,
        "totalpositivetests": 92,
        "totalcumtests": 12105
    },
    {
        "id": "Marlborough",
        "totalcumtests": 63339,
        "datepublished": "01/21/2021",
        "adir": 89.9,
        "casecount": 549,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 6352,
        "totalcasecount": 3629,
        "totalpositivetests": 584,
        "percentpositivity": "9.19%"
    },
    {
        "id": "Marshfield",
        "adir": 83.5,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 1248,
        "casecount": 303,
        "total2weektests": 3059,
        "totalcumtests": 25773,
        "datepublished": "01/21/2021",
        "totalpositivetests": 323,
        "percentpositivity": "10.56%"
    },
    {
        "id": "Mashpee",
        "totalcumtests": 16260,
        "datepublished": "01/21/2021",
        "totalcasecount": 451,
        "totalpositivetests": 123,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 52.9,
        "casecount": 115,
        "percentpositivity": "7.45%",
        "total2weektests": 1652
    },
    {
        "id": "Mattapoisett",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 7466,
        "totalpositivetests": 72,
        "percentpositivity": "6.98%",
        "datepublished": "01/21/2021",
        "casecount": 65,
        "adir": 81,
        "totalcasecount": 323,
        "total2weektests": 1031
    },
    {
        "id": "Maynard",
        "casecount": 83,
        "adir": 57,
        "datepublished": "01/21/2021",
        "totalcumtests": 13078,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 428,
        "percentpositivity": "7.00%",
        "totalpositivetests": 93,
        "total2weektests": 1328
    },
    {
        "id": "Medfield",
        "totalpositivetests": 89,
        "percentpositivity": "4.48%",
        "casecount": 82,
        "datepublished": "01/21/2021",
        "totalcumtests": 17141,
        "adir": 52,
        "total2weektests": 1985,
        "totalcasecount": 368,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Medford",
        "total2weektests": 14326,
        "percentpositivity": "5.02%",
        "totalpositivetests": 719,
        "adir": 74.1,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 182439,
        "totalcasecount": 3888,
        "casecount": 630
    },
    {
        "id": "Medway",
        "totalcumtests": 15279,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 76,
        "adir": 41.5,
        "totalpositivetests": 78,
        "totalcasecount": 480,
        "percentpositivity": "5.36%",
        "total2weektests": 1454
    },
    {
        "id": "Melrose",
        "adir": 51,
        "total2weektests": 6624,
        "percentpositivity": "3.53%",
        "totalcumtests": 52250,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 1427,
        "casecount": 207,
        "totalpositivetests": 234
    },
    {
        "id": "Mendon",
        "totalcumtests": 5870,
        "datepublished": "01/21/2021",
        "totalcasecount": 194,
        "adir": 24.7,
        "totalpositivetests": 22,
        "casecount": 20,
        "percentpositivity": "4.72%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 466
    },
    {
        "id": "Merrimac",
        "datepublished": "01/21/2021",
        "adir": 58.5,
        "casecount": 52,
        "percentpositivity": "7.73%",
        "totalcasecount": 277,
        "total2weektests": 789,
        "totalpositivetests": 61,
        "totalcumtests": 7638,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Methuen",
        "adir": 111.6,
        "total2weektests": 9446,
        "totalcasecount": 5680,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 993,
        "percentpositivity": "10.51%",
        "casecount": 841,
        "totalcumtests": 82926
    },
    {
        "id": "Middleborough",
        "totalcumtests": 28515,
        "datepublished": "01/21/2021",
        "total2weektests": 3479,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 281,
        "percentpositivity": "9.23%",
        "totalcasecount": 1360,
        "adir": 73.2,
        "totalpositivetests": 321
    },
    {
        "id": "Middlefield",
        "percentpositivity": "0%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 217,
        "adir": 0,
        "totalcasecount": 5,
        "casecount": 0,
        "datepublished": "01/21/2021",
        "total2weektests": 21,
        "totalpositivetests": 0
    },
    {
        "id": "Middleton",
        "totalpositivetests": 117,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 1493,
        "totalcumtests": 15197,
        "casecount": 104,
        "percentpositivity": "7.84%",
        "totalcasecount": 1099,
        "adir": 71.3
    },
    {
        "id": "Milford",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 301,
        "datepublished": "01/21/2021",
        "total2weektests": 3101,
        "totalcasecount": 2192,
        "totalpositivetests": 335,
        "totalcumtests": 34288,
        "adir": 73.3,
        "percentpositivity": "10.80%"
    },
    {
        "id": "Millbury",
        "adir": 78.9,
        "totalpositivetests": 167,
        "percentpositivity": "9.64%",
        "casecount": 151,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 1732,
        "totalcasecount": 901,
        "datepublished": "01/21/2021",
        "totalcumtests": 16242
    },
    {
        "id": "Millis",
        "adir": 62.7,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.02%",
        "total2weektests": 973,
        "casecount": 69,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 8909,
        "totalcasecount": 316,
        "totalpositivetests": 78
    },
    {
        "id": "Millville",
        "adir": 45.8,
        "totalpositivetests": 24,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 23,
        "totalcumtests": 2796,
        "totalcasecount": 125,
        "percentpositivity": "9.92%",
        "total2weektests": 242,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Milton",
        "total2weektests": 6545,
        "totalcumtests": 65051,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 75,
        "totalpositivetests": 322,
        "casecount": 302,
        "totalcasecount": 1632,
        "percentpositivity": "4.92%"
    },
    {
        "id": "Monroe",
        "percentpositivity": "0%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 72,
        "adir": 0,
        "totalpositivetests": 0,
        "casecount": 0,
        "total2weektests": 10,
        "totalcasecount": "<5"
    },
    {
        "id": "Monson",
        "totalpositivetests": 85,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "10.06%",
        "total2weektests": 845,
        "casecount": 72,
        "datepublished": "01/21/2021",
        "totalcasecount": 341,
        "adir": 61.3,
        "totalcumtests": 8506
    },
    {
        "id": "Montague",
        "total2weektests": 980,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 23,
        "totalcasecount": 180,
        "totalpositivetests": 26,
        "percentpositivity": "2.65%",
        "adir": 19.4,
        "totalcumtests": 9793,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Monterey",
        "total2weektests": 84,
        "totalcasecount": 14,
        "percentpositivity": "0%",
        "totalcumtests": 950,
        "adir": 0,
        "totalpositivetests": 0,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 0
    },
    {
        "id": "Montgomery",
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 24.2,
        "totalpositivetests": 4,
        "datepublished": "01/21/2021",
        "percentpositivity": "11.43%",
        "total2weektests": 35,
        "totalcumtests": 280,
        "totalcasecount": 15
    },
    {
        "id": "Mount Washington",
        "datepublished": "01/21/2021",
        "percentpositivity": "55.56%",
        "casecount": 5,
        "total2weektests": 9,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 271.9,
        "totalpositivetests": 5,
        "totalcumtests": 54,
        "totalcasecount": 5
    },
    {
        "id": "Nahant",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "4.90%",
        "datepublished": "01/21/2021",
        "totalcumtests": 6003,
        "totalpositivetests": 33,
        "adir": 66.3,
        "total2weektests": 674,
        "totalcasecount": 182,
        "casecount": 30
    },
    {
        "id": "Nantucket",
        "totalpositivetests": 181,
        "casecount": 180,
        "datepublished": "01/21/2021",
        "percentpositivity": "9.40%",
        "totalcasecount": 1005,
        "totalcumtests": 18305,
        "total2weektests": 1926,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 112.6
    },
    {
        "id": "Natick",
        "totalcumtests": 53987,
        "datepublished": "01/21/2021",
        "percentpositivity": "4.05%",
        "totalcasecount": 1356,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 6339,
        "totalpositivetests": 257,
        "adir": 47.6,
        "casecount": 240
    },
    {
        "id": "Needham",
        "datepublished": "01/21/2021",
        "total2weektests": 6237,
        "percentpositivity": "3.37%",
        "totalcumtests": 55235,
        "totalcasecount": 1122,
        "totalpositivetests": 210,
        "adir": 46.9,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 192
    },
    {
        "id": "New Ashford",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": "<5",
        "adir": 0,
        "total2weektests": 5,
        "datepublished": "01/21/2021",
        "totalcumtests": 102,
        "percentpositivity": "0%",
        "totalpositivetests": 0,
        "casecount": 0
    },
    {
        "id": "New Bedford",
        "casecount": 1862,
        "percentpositivity": "13.67%",
        "totalpositivetests": 2118,
        "adir": 133,
        "total2weektests": 15496,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 10322,
        "totalcumtests": 129830,
        "datepublished": "01/21/2021"
    },
    {
        "id": "New Braintree",
        "percentpositivity": "4.44%",
        "total2weektests": 90,
        "totalcasecount": 25,
        "adir": 26.9,
        "totalcumtests": 841,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 4,
        "datepublished": "01/21/2021"
    },
    {
        "id": "New Marlborough",
        "percentpositivity": "3.70%",
        "totalcumtests": 892,
        "adir": 14.1,
        "datepublished": "01/21/2021",
        "totalcasecount": 21,
        "totalpositivetests": 3,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 81
    },
    {
        "id": "New Salem",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 56,
        "datepublished": "01/21/2021",
        "totalcumtests": 934,
        "percentpositivity": "0%",
        "adir": 0,
        "totalpositivetests": 0,
        "totalcasecount": 8,
        "casecount": 0
    },
    {
        "id": "Newbury",
        "percentpositivity": "5.54%",
        "adir": 54.1,
        "totalpositivetests": 51,
        "totalcasecount": 231,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 50,
        "totalcumtests": 9080,
        "total2weektests": 920
    },
    {
        "id": "Newburyport",
        "casecount": 116,
        "datepublished": "01/21/2021",
        "totalcasecount": 793,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "4.24%",
        "totalcumtests": 28635,
        "adir": 46.7,
        "totalpositivetests": 129,
        "total2weektests": 3042
    },
    {
        "id": "Newton",
        "percentpositivity": "2.75%",
        "total2weektests": 20332,
        "totalcasecount": 2899,
        "adir": 37.8,
        "totalcumtests": 258087,
        "casecount": 485,
        "totalpositivetests": 559,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Norfolk",
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 1189,
        "totalpositivetests": 93,
        "percentpositivity": "7.82%",
        "totalcasecount": 796,
        "casecount": 89,
        "adir": 50.9,
        "totalcumtests": 14421
    },
    {
        "id": "North Adams",
        "total2weektests": 2109,
        "totalcasecount": 279,
        "casecount": 60,
        "datepublished": "01/21/2021",
        "totalcumtests": 19559,
        "adir": 33.3,
        "totalpositivetests": 64,
        "percentpositivity": "3.03%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "North Andover",
        "percentpositivity": "5.52%",
        "datepublished": "01/21/2021",
        "totalcasecount": 2125,
        "total2weektests": 6032,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 333,
        "casecount": 271,
        "totalcumtests": 93493,
        "adir": 63.9
    },
    {
        "id": "North Attleborough",
        "totalcasecount": 1454,
        "percentpositivity": "6.95%",
        "datepublished": "01/21/2021",
        "casecount": 205,
        "total2weektests": 3193,
        "totalpositivetests": 222,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 48.3,
        "totalcumtests": 30423
    },
    {
        "id": "North Brookfield",
        "percentpositivity": "7.42%",
        "datepublished": "01/21/2021",
        "totalpositivetests": 42,
        "totalcumtests": 4619,
        "totalcasecount": 192,
        "total2weektests": 566,
        "adir": 57.1,
        "casecount": 37,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "North Reading",
        "percentpositivity": "5.33%",
        "total2weektests": 2457,
        "totalpositivetests": 131,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 122,
        "totalcasecount": 919,
        "totalcumtests": 23926,
        "adir": 52.3,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Northampton",
        "percentpositivity": "2.70%",
        "totalcumtests": 56909,
        "adir": 31.1,
        "totalpositivetests": 139,
        "casecount": 127,
        "totalcasecount": 801,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 5142
    },
    {
        "id": "Northborough",
        "totalcasecount": 908,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 71.6,
        "percentpositivity": "4.50%",
        "totalpositivetests": 146,
        "total2weektests": 3247,
        "totalcumtests": 25029,
        "casecount": 136,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Northbridge",
        "totalcumtests": 21567,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "3.52%",
        "totalcasecount": 872,
        "adir": 31.4,
        "totalpositivetests": 86,
        "datepublished": "01/21/2021",
        "total2weektests": 2441,
        "casecount": 80
    },
    {
        "id": "Northfield",
        "adir": 24.2,
        "totalpositivetests": 11,
        "totalcasecount": 32,
        "casecount": 10,
        "totalcumtests": 3580,
        "total2weektests": 339,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "3.24%"
    },
    {
        "id": "Norton",
        "casecount": 144,
        "totalcasecount": 924,
        "totalcumtests": 49601,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.09%",
        "total2weektests": 2173,
        "totalpositivetests": 154,
        "adir": 51.7
    },
    {
        "id": "Norwell",
        "adir": 62.6,
        "datepublished": "01/21/2021",
        "totalcasecount": 444,
        "total2weektests": 1730,
        "casecount": 94,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "5.90%",
        "totalpositivetests": 102,
        "totalcumtests": 14182
    },
    {
        "id": "Norwood",
        "totalpositivetests": 350,
        "percentpositivity": "6.67%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 306,
        "adir": 72.2,
        "datepublished": "01/21/2021",
        "total2weektests": 5251,
        "totalcasecount": 2003,
        "totalcumtests": 44523
    },
    {
        "id": "Oak Bluffs",
        "totalcasecount": 167,
        "totalcumtests": 6004,
        "adir": 46.6,
        "total2weektests": 538,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "6.69%",
        "totalpositivetests": 36,
        "casecount": 34
    },
    {
        "id": "Oakham",
        "totalcumtests": 1899,
        "casecount": 10,
        "totalcasecount": 61,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "4.67%",
        "datepublished": "01/21/2021",
        "totalpositivetests": 10,
        "total2weektests": 214,
        "adir": 33.5
    },
    {
        "id": "Orange",
        "casecount": 46,
        "totalpositivetests": 50,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 8776,
        "datepublished": "01/21/2021",
        "totalcasecount": 202,
        "total2weektests": 901,
        "adir": 40.4,
        "percentpositivity": "5.55%"
    },
    {
        "id": "Orleans",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 4390,
        "total2weektests": 477,
        "percentpositivity": "5.87%",
        "datepublished": "01/21/2021",
        "casecount": 24,
        "adir": 30.5,
        "totalcasecount": 102,
        "totalpositivetests": 28
    },
    {
        "id": "Otis",
        "percentpositivity": "7.27%",
        "adir": 45.6,
        "totalcasecount": 35,
        "datepublished": "01/21/2021",
        "casecount": 12,
        "total2weektests": 165,
        "totalcumtests": 1241,
        "totalpositivetests": 12,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Oxford",
        "totalcasecount": 670,
        "datepublished": "01/21/2021",
        "adir": 54.5,
        "totalpositivetests": 116,
        "percentpositivity": "8.13%",
        "total2weektests": 1427,
        "totalcumtests": 13895,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 105
    },
    {
        "id": "Palmer",
        "datepublished": "01/21/2021",
        "adir": 72.5,
        "total2weektests": 1451,
        "totalcumtests": 13290,
        "totalpositivetests": 138,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "9.51%",
        "totalcasecount": 565,
        "casecount": 120
    },
    {
        "id": "Paxton",
        "totalcasecount": 292,
        "total2weektests": 599,
        "casecount": 55,
        "percentpositivity": "10.18%",
        "adir": 79.3,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 15227,
        "totalpositivetests": 61
    },
    {
        "id": "Peabody",
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "9.29%",
        "totalpositivetests": 954,
        "casecount": 841,
        "adir": 107.3,
        "totalcumtests": 85971,
        "total2weektests": 10267,
        "totalcasecount": 5035
    },
    {
        "id": "Pelham",
        "adir": 5.8,
        "totalcumtests": 886,
        "totalpositivetests": 1,
        "casecount": "<5",
        "percentpositivity": "1.43%",
        "total2weektests": 70,
        "totalcasecount": 17,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Pembroke",
        "percentpositivity": "9.79%",
        "casecount": 198,
        "totalpositivetests": 216,
        "total2weektests": 2207,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 824,
        "datepublished": "01/21/2021",
        "totalcumtests": 17879,
        "adir": 75.3
    },
    {
        "id": "Pepperell",
        "adir": 35.4,
        "totalcumtests": 10143,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 63,
        "casecount": 61,
        "totalcasecount": 349,
        "percentpositivity": "6.85%",
        "datepublished": "01/21/2021",
        "total2weektests": 920
    },
    {
        "id": "Peru",
        "totalcasecount": 8,
        "casecount": 5,
        "percentpositivity": "17.14%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 35,
        "totalpositivetests": 6,
        "datepublished": "01/21/2021",
        "totalcumtests": 336,
        "adir": 42.8
    },
    {
        "id": "Petersham",
        "percentpositivity": "4.12%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": "<5",
        "totalpositivetests": 4,
        "totalcasecount": 28,
        "totalcumtests": 1169,
        "adir": 22.5,
        "datepublished": "01/21/2021",
        "total2weektests": 97
    },
    {
        "id": "Phillipston",
        "totalcasecount": 51,
        "totalcumtests": 1325,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 10,
        "total2weektests": 151,
        "datepublished": "01/21/2021",
        "casecount": 10,
        "percentpositivity": "6.62%",
        "adir": 41.7
    },
    {
        "id": "Pittsfield",
        "total2weektests": 7619,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "casecount": 407,
        "totalcasecount": 1959,
        "totalpositivetests": 439,
        "percentpositivity": "5.76%",
        "totalcumtests": 59242,
        "adir": 66.1
    },
    {
        "id": "Plainfield",
        "totalpositivetests": 1,
        "adir": 11.4,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 566,
        "total2weektests": 54,
        "casecount": "<5",
        "totalcasecount": 12,
        "percentpositivity": "1.85%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Plainville",
        "percentpositivity": "7.48%",
        "totalcasecount": 404,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 73,
        "datepublished": "01/21/2021",
        "totalcumtests": 9980,
        "total2weektests": 1043,
        "adir": 56.6,
        "totalpositivetests": 78
    },
    {
        "id": "Plymouth",
        "datepublished": "01/21/2021",
        "casecount": 785,
        "percentpositivity": "8.97%",
        "total2weektests": 9349,
        "adir": 89.4,
        "totalcumtests": 70603,
        "totalcasecount": 3095,
        "totalpositivetests": 839,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Plympton",
        "percentpositivity": "12.26%",
        "totalcasecount": 99,
        "casecount": 35,
        "datepublished": "01/21/2021",
        "adir": 83.1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 310,
        "totalpositivetests": 38,
        "totalcumtests": 2601
    },
    {
        "id": "Princeton",
        "adir": 28.7,
        "total2weektests": 411,
        "percentpositivity": "3.65%",
        "casecount": 13,
        "totalcumtests": 4417,
        "totalpositivetests": 15,
        "datepublished": "01/21/2021",
        "totalcasecount": 106,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Provincetown",
        "total2weektests": 258,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 3437,
        "datepublished": "01/21/2021",
        "percentpositivity": "3.49%",
        "casecount": 8,
        "totalcasecount": 55,
        "totalpositivetests": 9,
        "adir": 22.1
    },
    {
        "id": "Quincy",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 5102,
        "total2weektests": 14859,
        "totalcumtests": 132435,
        "percentpositivity": "6.52%",
        "casecount": 870,
        "adir": 61.2,
        "datepublished": "01/21/2021",
        "totalpositivetests": 969
    },
    {
        "id": "Randolph",
        "totalcasecount": 2905,
        "totalcumtests": 49865,
        "percentpositivity": "9.64%",
        "adir": 101.6,
        "casecount": 490,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 5713,
        "totalpositivetests": 551,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Raynham",
        "totalcasecount": 1044,
        "totalpositivetests": 208,
        "datepublished": "01/21/2021",
        "totalcumtests": 18474,
        "percentpositivity": "10.06%",
        "casecount": 181,
        "adir": 85.5,
        "total2weektests": 2067,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Reading",
        "totalcumtests": 37932,
        "total2weektests": 4344,
        "percentpositivity": "6.35%",
        "casecount": 251,
        "datepublished": "01/21/2021",
        "totalcasecount": 1410,
        "adir": 64.8,
        "totalpositivetests": 276,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Rehoboth",
        "totalcumtests": 11059,
        "total2weektests": 1133,
        "percentpositivity": "9.71%",
        "adir": 55.1,
        "totalpositivetests": 110,
        "datepublished": "01/21/2021",
        "casecount": 98,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 682
    },
    {
        "id": "Revere",
        "percentpositivity": "11.31%",
        "total2weektests": 12948,
        "totalcasecount": 8266,
        "totalcumtests": 110879,
        "casecount": 1156,
        "totalpositivetests": 1464,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "adir": 135.7
    },
    {
        "id": "Richmond",
        "totalcumtests": 1354,
        "adir": 27.4,
        "casecount": 5,
        "totalpositivetests": 6,
        "percentpositivity": "3.80%",
        "total2weektests": 158,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 30
    },
    {
        "id": "Rochester",
        "percentpositivity": "10.79%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 5856,
        "adir": 98.2,
        "totalpositivetests": 87,
        "casecount": 78,
        "totalcasecount": 317,
        "total2weektests": 806
    },
    {
        "id": "Rockland",
        "adir": 95.5,
        "casecount": 242,
        "percentpositivity": "10.03%",
        "total2weektests": 2683,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 1253,
        "totalpositivetests": 269,
        "datepublished": "01/21/2021",
        "totalcumtests": 20734
    },
    {
        "id": "Rockport",
        "total2weektests": 747,
        "casecount": 33,
        "totalcumtests": 6871,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 200,
        "percentpositivity": "4.95%",
        "adir": 36.5,
        "totalpositivetests": 37,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Rowe",
        "adir": 0,
        "total2weektests": 30,
        "datepublished": "01/21/2021",
        "totalcasecount": 7,
        "casecount": 0,
        "percentpositivity": "0%",
        "totalcumtests": 349,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 0
    },
    {
        "id": "Rowley",
        "percentpositivity": "8.55%",
        "total2weektests": 784,
        "datepublished": "01/21/2021",
        "totalcumtests": 7530,
        "totalpositivetests": 67,
        "totalcasecount": 292,
        "adir": 71.7,
        "casecount": 62,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Royalston",
        "casecount": 10,
        "totalpositivetests": 11,
        "adir": 56.1,
        "datepublished": "01/21/2021",
        "percentpositivity": "7.91%",
        "totalcumtests": 1264,
        "total2weektests": 139,
        "totalcasecount": 45,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Russell",
        "total2weektests": 189,
        "totalpositivetests": 14,
        "percentpositivity": "7.41%",
        "totalcumtests": 1675,
        "datepublished": "01/21/2021",
        "adir": 45.2,
        "casecount": 12,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 73
    },
    {
        "id": "Rutland",
        "total2weektests": 1060,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.77%",
        "totalpositivetests": 93,
        "casecount": 90,
        "totalcasecount": 386,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 70.5,
        "totalcumtests": 10922
    },
    {
        "id": "Salem",
        "totalcasecount": 3443,
        "adir": 93.1,
        "total2weektests": 9376,
        "casecount": 587,
        "datepublished": "01/21/2021",
        "totalcumtests": 86904,
        "totalpositivetests": 715,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.63%"
    },
    {
        "id": "Salisbury",
        "totalpositivetests": 95,
        "percentpositivity": "9.64%",
        "totalcumtests": 9182,
        "adir": 69.4,
        "datepublished": "01/21/2021",
        "total2weektests": 985,
        "totalcasecount": 467,
        "casecount": 86,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Sandisfield",
        "casecount": 9,
        "totalcasecount": 27,
        "adir": 69,
        "percentpositivity": "6.79%",
        "total2weektests": 162,
        "totalpositivetests": 11,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 1278
    },
    {
        "id": "Sandwich",
        "totalcasecount": 656,
        "totalcumtests": 19101,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 248,
        "casecount": 231,
        "percentpositivity": "11.24%",
        "adir": 78.3,
        "total2weektests": 2207
    },
    {
        "id": "Saugus",
        "datepublished": "01/21/2021",
        "totalcumtests": 48199,
        "total2weektests": 5908,
        "percentpositivity": "10.14%",
        "casecount": 498,
        "totalpositivetests": 599,
        "adir": 124.9,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 3015
    },
    {
        "id": "Savoy",
        "totalcasecount": 12,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "3.66%",
        "total2weektests": 82,
        "totalcumtests": 578,
        "casecount": "<5",
        "adir": 34.5,
        "totalpositivetests": 3
    },
    {
        "id": "Scituate",
        "adir": 88,
        "totalpositivetests": 234,
        "datepublished": "01/21/2021",
        "total2weektests": 2844,
        "totalcasecount": 826,
        "totalcumtests": 21249,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.23%",
        "casecount": 223
    },
    {
        "id": "Seekonk",
        "total2weektests": 1267,
        "totalpositivetests": 120,
        "datepublished": "01/21/2021",
        "totalcasecount": 923,
        "percentpositivity": "9.47%",
        "adir": 55.6,
        "totalcumtests": 12643,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 109
    },
    {
        "id": "Sharon",
        "adir": 46.9,
        "total2weektests": 2793,
        "casecount": 120,
        "percentpositivity": "4.65%",
        "datepublished": "01/21/2021",
        "totalcasecount": 603,
        "totalcumtests": 23545,
        "totalpositivetests": 130,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Sheffield",
        "totalcumtests": 8444,
        "totalpositivetests": 14,
        "adir": 30.4,
        "totalcasecount": 68,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 13,
        "percentpositivity": "1.27%",
        "datepublished": "01/21/2021",
        "total2weektests": 1104
    },
    {
        "id": "Shelburne",
        "total2weektests": 356,
        "datepublished": "01/21/2021",
        "totalpositivetests": 3,
        "totalcasecount": 25,
        "percentpositivity": "0.84%",
        "totalcumtests": 3776,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 11.7
    },
    {
        "id": "Sherborn",
        "casecount": 24,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcumtests": 5555,
        "totalpositivetests": 27,
        "adir": 45.4,
        "total2weektests": 624,
        "totalcasecount": 121,
        "percentpositivity": "4.33%"
    },
    {
        "id": "Shirley",
        "total2weektests": 701,
        "adir": 43.6,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 710,
        "percentpositivity": "8.27%",
        "totalpositivetests": 58,
        "datepublished": "01/21/2021",
        "totalcumtests": 9454,
        "casecount": 52
    },
    {
        "id": "Shrewsbury",
        "datepublished": "01/21/2021",
        "totalcasecount": 2128,
        "percentpositivity": "7.52%",
        "total2weektests": 5985,
        "totalcumtests": 52940,
        "adir": 74.7,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 450,
        "casecount": 413
    },
    {
        "id": "Shutesbury",
        "percentpositivity": "0.50%",
        "adir": 4.1,
        "totalcumtests": 2350,
        "datepublished": "01/21/2021",
        "casecount": "<5",
        "totalcasecount": 21,
        "total2weektests": 200,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 1
    },
    {
        "id": "Somerset",
        "total2weektests": 2435,
        "percentpositivity": "11.33%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 243,
        "adir": 93.7,
        "datepublished": "01/21/2021",
        "totalcasecount": 1491,
        "totalcumtests": 22713,
        "totalpositivetests": 276
    },
    {
        "id": "Somerville",
        "total2weektests": 19371,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 3973,
        "casecount": 602,
        "percentpositivity": "3.54%",
        "totalpositivetests": 686,
        "totalcumtests": 285478,
        "adir": 56.8
    },
    {
        "id": "South Hadley",
        "datepublished": "01/21/2021",
        "adir": 45.4,
        "totalcumtests": 29161,
        "percentpositivity": "4.28%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 133,
        "total2weektests": 3104,
        "casecount": 115,
        "totalcasecount": 706
    },
    {
        "id": "Southampton",
        "totalcasecount": 254,
        "adir": 61.7,
        "totalpositivetests": 66,
        "percentpositivity": "7.47%",
        "totalcumtests": 7248,
        "total2weektests": 884,
        "datepublished": "01/21/2021",
        "casecount": 52,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Southborough",
        "casecount": 44,
        "totalcasecount": 327,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 47,
        "adir": 32.5,
        "percentpositivity": "2.21%",
        "total2weektests": 2129,
        "totalcumtests": 19531
    },
    {
        "id": "Southbridge",
        "totalpositivetests": 307,
        "total2weektests": 2365,
        "adir": 113.7,
        "percentpositivity": "12.98%",
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 19847,
        "casecount": 267,
        "totalcasecount": 1292
    },
    {
        "id": "Southwick",
        "percentpositivity": "7.28%",
        "total2weektests": 893,
        "adir": 40.8,
        "casecount": 56,
        "datepublished": "01/21/2021",
        "totalcumtests": 9191,
        "totalpositivetests": 65,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 365
    },
    {
        "id": "Spencer",
        "adir": 67.3,
        "percentpositivity": "8.82%",
        "totalcumtests": 13235,
        "totalcasecount": 575,
        "datepublished": "01/21/2021",
        "total2weektests": 1304,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 115,
        "casecount": 108
    },
    {
        "id": "Springfield",
        "datepublished": "01/21/2021",
        "percentpositivity": "10.70%",
        "totalcumtests": 225339,
        "total2weektests": 24141,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 98.1,
        "casecount": 2146,
        "totalcasecount": 14157,
        "totalpositivetests": 2583
    },
    {
        "id": "Sterling",
        "datepublished": "01/21/2021",
        "total2weektests": 1167,
        "casecount": 65,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 59.1,
        "totalcasecount": 509,
        "percentpositivity": "5.74%",
        "totalcumtests": 12316,
        "totalpositivetests": 67
    },
    {
        "id": "Stockbridge",
        "casecount": 18,
        "percentpositivity": "3.75%",
        "total2weektests": 480,
        "totalpositivetests": 18,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 56,
        "adir": 75.4,
        "totalcumtests": 2875,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Stoneham",
        "total2weektests": 4612,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 279,
        "casecount": 245,
        "adir": 78.6,
        "totalcumtests": 40972,
        "totalcasecount": 1716,
        "percentpositivity": "6.05%"
    },
    {
        "id": "Stoughton",
        "datepublished": "01/21/2021",
        "total2weektests": 4835,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 2065,
        "percentpositivity": "9.53%",
        "adir": 108.6,
        "casecount": 421,
        "totalcumtests": 36441,
        "totalpositivetests": 461
    },
    {
        "id": "Stow",
        "totalpositivetests": 31,
        "percentpositivity": "3.60%",
        "casecount": 29,
        "total2weektests": 861,
        "totalcasecount": 173,
        "adir": 28.6,
        "totalcumtests": 8708,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Sturbridge",
        "totalcasecount": 436,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 102,
        "datepublished": "01/21/2021",
        "percentpositivity": "9.26%",
        "adir": 68.9,
        "total2weektests": 1101,
        "totalcumtests": 10072,
        "totalpositivetests": 102
    },
    {
        "id": "Sudbury",
        "totalcasecount": 545,
        "total2weektests": 3332,
        "totalpositivetests": 117,
        "percentpositivity": "3.51%",
        "totalcumtests": 25898,
        "casecount": 106,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "adir": 42.5
    },
    {
        "id": "Sunderland",
        "totalcumtests": 14318,
        "percentpositivity": "3.63%",
        "datepublished": "01/21/2021",
        "casecount": 29,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 121,
        "adir": 55.7,
        "total2weektests": 827,
        "totalpositivetests": 30
    },
    {
        "id": "Sutton",
        "datepublished": "01/21/2021",
        "totalcasecount": 463,
        "totalcumtests": 10389,
        "percentpositivity": "9.07%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 88,
        "total2weektests": 1036,
        "totalpositivetests": 94,
        "adir": 70.2
    },
    {
        "id": "Swampscott",
        "percentpositivity": "5.15%",
        "totalcumtests": 27319,
        "adir": 71.9,
        "casecount": 137,
        "totalcasecount": 803,
        "total2weektests": 3050,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 157
    },
    {
        "id": "Swansea",
        "datepublished": "01/21/2021",
        "totalcasecount": 1258,
        "casecount": 233,
        "percentpositivity": "10.92%",
        "totalcumtests": 19503,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 263,
        "total2weektests": 2409,
        "adir": 104.3
    },
    {
        "id": "Taunton",
        "totalcumtests": 74514,
        "percentpositivity": "10.44%",
        "datepublished": "01/21/2021",
        "total2weektests": 8436,
        "casecount": 780,
        "totalpositivetests": 881,
        "totalcasecount": 4225,
        "adir": 96.8,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Templeton",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 438,
        "adir": 90.3,
        "datepublished": "01/21/2021",
        "total2weektests": 1069,
        "percentpositivity": "11.13%",
        "totalpositivetests": 119,
        "totalcumtests": 10076,
        "casecount": 114
    },
    {
        "id": "Tewksbury",
        "total2weektests": 5805,
        "totalcasecount": 2437,
        "adir": 76.7,
        "percentpositivity": "6.13%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 356,
        "casecount": 331,
        "totalcumtests": 53267
    },
    {
        "id": "Tisbury",
        "totalcumtests": 11207,
        "casecount": 49,
        "adir": 83.9,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 52,
        "total2weektests": 919,
        "percentpositivity": "5.66%",
        "totalcasecount": 211,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Tolland",
        "totalcasecount": 8,
        "totalpositivetests": 2,
        "datepublished": "01/21/2021",
        "adir": 34.5,
        "casecount": "<5",
        "total2weektests": 11,
        "percentpositivity": "18.18%",
        "totalcumtests": 161,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Topsfield",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 330,
        "totalcumtests": 10603,
        "totalpositivetests": 59,
        "total2weektests": 1337,
        "percentpositivity": "4.41%",
        "adir": 65.5,
        "casecount": 53,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Townsend",
        "totalpositivetests": 61,
        "casecount": 58,
        "total2weektests": 741,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.23%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 45.5,
        "totalcumtests": 8413,
        "totalcasecount": 305
    },
    {
        "id": "Truro",
        "totalcasecount": 22,
        "datepublished": "01/21/2021",
        "totalcumtests": 1508,
        "adir": 10.9,
        "totalpositivetests": 3,
        "casecount": "<5",
        "percentpositivity": "2.75%",
        "total2weektests": 109,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Tyngsborough",
        "totalcumtests": 13662,
        "percentpositivity": "8.84%",
        "adir": 65.6,
        "casecount": 110,
        "totalcasecount": 804,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 1391,
        "totalpositivetests": 123
    },
    {
        "id": "Tyringham",
        "total2weektests": 42,
        "totalpositivetests": 3,
        "totalcumtests": 310,
        "datepublished": "01/21/2021",
        "totalcasecount": 8,
        "adir": 59.1,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "7.14%"
    },
    {
        "id": "Upton",
        "casecount": 38,
        "percentpositivity": "5.21%",
        "totalcumtests": 7760,
        "total2weektests": 806,
        "datepublished": "01/21/2021",
        "totalpositivetests": 42,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 207,
        "adir": 29.5
    },
    {
        "id": "Uxbridge",
        "totalcasecount": 611,
        "adir": 46.7,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 112,
        "totalcumtests": 14222,
        "casecount": 102,
        "percentpositivity": "8.07%",
        "total2weektests": 1388
    },
    {
        "id": "Wakefield",
        "casecount": 295,
        "datepublished": "01/21/2021",
        "total2weektests": 4857,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 43221,
        "totalcasecount": 1617,
        "percentpositivity": "6.75%",
        "adir": 77.7,
        "totalpositivetests": 328
    },
    {
        "id": "Wales",
        "datepublished": "01/21/2021",
        "totalpositivetests": 11,
        "totalcasecount": 56,
        "percentpositivity": "6.83%",
        "casecount": 11,
        "totalcumtests": 1428,
        "total2weektests": 161,
        "adir": 41.1,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Walpole",
        "totalcumtests": 34241,
        "casecount": 273,
        "adir": 74.8,
        "percentpositivity": "7.71%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 292,
        "datepublished": "01/21/2021",
        "total2weektests": 3788,
        "totalcasecount": 1293
    },
    {
        "id": "Waltham",
        "total2weektests": 11516,
        "datepublished": "01/21/2021",
        "totalcasecount": 3991,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 642,
        "totalpositivetests": 723,
        "percentpositivity": "6.28%",
        "adir": 69,
        "totalcumtests": 177572
    },
    {
        "id": "Ware",
        "percentpositivity": "7.83%",
        "casecount": 85,
        "totalcasecount": 326,
        "totalpositivetests": 94,
        "total2weektests": 1201,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 11116,
        "adir": 59.8
    },
    {
        "id": "Wareham",
        "datepublished": "01/21/2021",
        "percentpositivity": "8.46%",
        "totalcumtests": 21362,
        "totalpositivetests": 204,
        "total2weektests": 2411,
        "casecount": 185,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 54.6,
        "totalcasecount": 1066
    },
    {
        "id": "Warren",
        "datepublished": "01/21/2021",
        "percentpositivity": "9.85%",
        "totalcumtests": 4051,
        "totalcasecount": 143,
        "totalpositivetests": 45,
        "casecount": 43,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 56.4,
        "total2weektests": 457
    },
    {
        "id": "Warwick",
        "adir": 9.7,
        "datepublished": "01/21/2021",
        "totalcumtests": 621,
        "casecount": "<5",
        "totalcasecount": 6,
        "percentpositivity": "1.79%",
        "totalpositivetests": 1,
        "total2weektests": 56,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Washington",
        "totalcumtests": 393,
        "casecount": "<5",
        "totalcasecount": "<5",
        "adir": 32.1,
        "percentpositivity": "4.76%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 42,
        "totalpositivetests": 2
    },
    {
        "id": "Watertown",
        "adir": 63.8,
        "casecount": 295,
        "total2weektests": 7609,
        "datepublished": "01/21/2021",
        "totalcasecount": 1701,
        "totalcumtests": 62201,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 342,
        "percentpositivity": "4.49%"
    },
    {
        "id": "Wayland",
        "datepublished": "01/21/2021",
        "total2weektests": 2924,
        "casecount": 64,
        "percentpositivity": "2.43%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 71,
        "totalcumtests": 22243,
        "adir": 34.6,
        "totalcasecount": 431
    },
    {
        "id": "Webster",
        "casecount": 195,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 81.1,
        "percentpositivity": "8.07%",
        "datepublished": "01/21/2021",
        "totalcasecount": 1271,
        "totalcumtests": 25448,
        "total2weektests": 2886,
        "totalpositivetests": 233
    },
    {
        "id": "Wellesley",
        "casecount": 104,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 7406,
        "totalpositivetests": 119,
        "percentpositivity": "1.61%",
        "totalcumtests": 107261,
        "adir": 25,
        "totalcasecount": 809,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Wellfleet",
        "totalcasecount": 36,
        "totalpositivetests": 7,
        "casecount": 7,
        "adir": 18.1,
        "total2weektests": 153,
        "percentpositivity": "4.58%",
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 2094
    },
    {
        "id": "Wendell",
        "percentpositivity": "0%",
        "casecount": 0,
        "totalcumtests": 922,
        "adir": 0,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 0,
        "totalcasecount": 9,
        "total2weektests": 82
    },
    {
        "id": "Wenham",
        "totalpositivetests": 45,
        "totalcasecount": 196,
        "casecount": 43,
        "datepublished": "01/21/2021",
        "adir": 59,
        "total2weektests": 728,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 8463,
        "percentpositivity": "6.18%"
    },
    {
        "id": "West Boylston",
        "adir": 105.7,
        "totalcasecount": 477,
        "totalcumtests": 10321,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 116,
        "datepublished": "01/21/2021",
        "percentpositivity": "11.18%",
        "total2weektests": 1199,
        "totalpositivetests": 134
    },
    {
        "id": "West Bridgewater",
        "percentpositivity": "9.18%",
        "totalcasecount": 557,
        "total2weektests": 1253,
        "casecount": 101,
        "totalpositivetests": 115,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 11303,
        "adir": 99,
        "datepublished": "01/21/2021"
    },
    {
        "id": "West Brookfield",
        "casecount": 41,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.19%",
        "total2weektests": 537,
        "totalcumtests": 5400,
        "totalpositivetests": 44,
        "totalcasecount": 176,
        "adir": 79.1
    },
    {
        "id": "West Newbury",
        "casecount": 26,
        "adir": 46,
        "totalcumtests": 5159,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalpositivetests": 26,
        "totalcasecount": 133,
        "percentpositivity": "5.03%",
        "total2weektests": 517
    },
    {
        "id": "West Springfield",
        "percentpositivity": "10.38%",
        "totalcumtests": 35086,
        "datepublished": "01/21/2021",
        "totalcasecount": 1929,
        "total2weektests": 3728,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 326,
        "totalpositivetests": 387,
        "adir": 79.3
    },
    {
        "id": "West Stockbridge",
        "casecount": "<5",
        "totalcumtests": 1555,
        "totalpositivetests": 4,
        "adir": 24.3,
        "total2weektests": 188,
        "totalcasecount": 31,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "2.13%"
    },
    {
        "id": "West Tisbury",
        "total2weektests": 319,
        "totalcumtests": 3979,
        "adir": 34.8,
        "casecount": 14,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 15,
        "totalcasecount": 74,
        "datepublished": "01/21/2021",
        "percentpositivity": "4.70%"
    },
    {
        "id": "Westborough",
        "totalcasecount": 1071,
        "totalpositivetests": 130,
        "percentpositivity": "3.65%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 30687,
        "datepublished": "01/21/2021",
        "total2weektests": 3562,
        "casecount": 122,
        "adir": 46.6
    },
    {
        "id": "Westfield",
        "casecount": 411,
        "datepublished": "01/21/2021",
        "percentpositivity": "8.74%",
        "totalcumtests": 45834,
        "adir": 71,
        "totalpositivetests": 466,
        "total2weektests": 5330,
        "totalcasecount": 2124,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Westford",
        "totalpositivetests": 164,
        "datepublished": "01/21/2021",
        "totalcumtests": 25653,
        "adir": 49.5,
        "percentpositivity": "6.43%",
        "casecount": 160,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 881,
        "total2weektests": 2550
    },
    {
        "id": "Westhampton",
        "casecount": 13,
        "percentpositivity": "12.28%",
        "total2weektests": 114,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalpositivetests": 14,
        "datepublished": "01/21/2021",
        "totalcasecount": 45,
        "totalcumtests": 1009,
        "adir": 54.3
    },
    {
        "id": "Westminster",
        "adir": 87.9,
        "datepublished": "01/21/2021",
        "percentpositivity": "10.15%",
        "casecount": 90,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 8536,
        "totalcasecount": 344,
        "total2weektests": 916,
        "totalpositivetests": 93
    },
    {
        "id": "Weston",
        "adir": 37.7,
        "total2weektests": 3605,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "percentpositivity": "1.72%",
        "totalcumtests": 23899,
        "totalcasecount": 365,
        "casecount": 58,
        "totalpositivetests": 62
    },
    {
        "id": "Westport",
        "percentpositivity": "11.74%",
        "totalcasecount": 1106,
        "casecount": 225,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 2164,
        "adir": 95.9,
        "totalpositivetests": 254,
        "totalcumtests": 18216
    },
    {
        "id": "Westwood",
        "adir": 77.3,
        "datepublished": "01/21/2021",
        "totalcasecount": 673,
        "percentpositivity": "6.02%",
        "total2weektests": 2823,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 159,
        "totalpositivetests": 170,
        "totalcumtests": 21834
    },
    {
        "id": "Weymouth",
        "datepublished": "01/21/2021",
        "adir": 89.6,
        "total2weektests": 8648,
        "totalcasecount": 3459,
        "percentpositivity": "8.96%",
        "casecount": 705,
        "totalcumtests": 64933,
        "totalpositivetests": 775,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Whately",
        "adir": 34.4,
        "casecount": 7,
        "total2weektests": 120,
        "totalcumtests": 1125,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 49,
        "totalpositivetests": 11,
        "datepublished": "01/21/2021",
        "percentpositivity": "9.17%"
    },
    {
        "id": "Whitman",
        "adir": 75.8,
        "totalpositivetests": 172,
        "totalcasecount": 891,
        "totalcumtests": 15849,
        "casecount": 165,
        "percentpositivity": "9.77%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "total2weektests": 1761
    },
    {
        "id": "Wilbraham",
        "casecount": 143,
        "totalcasecount": 943,
        "datepublished": "01/21/2021",
        "totalpositivetests": 183,
        "totalcumtests": 29879,
        "total2weektests": 3166,
        "percentpositivity": "5.78%",
        "adir": 70.3,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Williamsburg",
        "datepublished": "01/21/2021",
        "totalcasecount": 47,
        "totalcumtests": 4517,
        "total2weektests": 444,
        "percentpositivity": "0.90%",
        "totalpositivetests": 4,
        "adir": 11.6,
        "casecount": "<5",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download"
    },
    {
        "id": "Williamstown",
        "totalcasecount": 186,
        "percentpositivity": "0.85%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 16,
        "totalcumtests": 47309,
        "total2weektests": 1873,
        "adir": 15.9,
        "datepublished": "01/21/2021",
        "totalpositivetests": 16
    },
    {
        "id": "Wilmington",
        "totalpositivetests": 286,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "8.12%",
        "totalcumtests": 29606,
        "casecount": 264,
        "datepublished": "01/21/2021",
        "adir": 77.1,
        "total2weektests": 3524,
        "totalcasecount": 1616
    },
    {
        "id": "Winchendon",
        "percentpositivity": "9.27%",
        "totalpositivetests": 115,
        "total2weektests": 1240,
        "datepublished": "01/21/2021",
        "adir": 71,
        "totalcumtests": 10518,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "casecount": 107,
        "totalcasecount": 452
    },
    {
        "id": "Winchester",
        "datepublished": "01/21/2021",
        "totalpositivetests": 191,
        "adir": 55.1,
        "total2weektests": 5708,
        "casecount": 172,
        "totalcumtests": 42273,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "percentpositivity": "3.35%",
        "totalcasecount": 883
    },
    {
        "id": "Windsor",
        "adir": 50.7,
        "totalcasecount": 14,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcumtests": 694,
        "totalpositivetests": 6,
        "casecount": 6,
        "total2weektests": 90,
        "percentpositivity": "6.67%",
        "datepublished": "01/21/2021"
    },
    {
        "id": "Winthrop",
        "datepublished": "01/21/2021",
        "totalcumtests": 49127,
        "casecount": 248,
        "total2weektests": 5438,
        "percentpositivity": "5.83%",
        "totalcasecount": 1747,
        "totalpositivetests": 317,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "adir": 93.9
    },
    {
        "id": "Woburn",
        "percentpositivity": "7.29%",
        "totalcumtests": 61550,
        "totalpositivetests": 567,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "totalcasecount": 3170,
        "adir": 85.3,
        "casecount": 496,
        "total2weektests": 7781,
        "datepublished": "01/21/2021"
    },
    {
        "id": "Worcester",
        "casecount": 2421,
        "percentpositivity": "7.41%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "adir": 90.3,
        "totalcumtests": 481229,
        "totalpositivetests": 2674,
        "totalcasecount": 17836,
        "total2weektests": 36095
    },
    {
        "id": "Worthington",
        "datepublished": "01/21/2021",
        "casecount": "<5",
        "totalcumtests": 1228,
        "adir": 6.8,
        "percentpositivity": "1.53%",
        "totalpositivetests": 2,
        "totalcasecount": 21,
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 131
    },
    {
        "id": "Wrentham",
        "totalcasecount": 730,
        "percentpositivity": "5.63%",
        "totalpositivetests": 116,
        "casecount": 112,
        "totalcumtests": 19734,
        "datepublished": "01/21/2021",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "total2weektests": 2062,
        "adir": 71
    },
    {
        "id": "Yarmouth",
        "adir": 49,
        "percentpositivity": "5.98%",
        "source": "https://www.mass.gov/doc/weekly-covid-19-public-health-report-january-21-2021/download",
        "datepublished": "01/21/2021",
        "totalcasecount": 866,
        "totalpositivetests": 185,
        "casecount": 165,
        "total2weektests": 3096,
        "totalcumtests": 25152
    }
]

export default towndata;
